import { Reducer } from '../types/reducer'

export function reduceReducers<S, A>(initialState: S, ...reducers: Reducer<S, A>[]): Reducer<S, A> {
  return function(state: S, action: A): S {
    if (!state) {
      return initialState
    }

    return reducers.reduce<S>((currentState, reducer) => reducer(currentState, action), state)
  }
}
